import axios from 'axios';
import apiConfig from '../../api.config';

export default async function invoiceDeleteDocumentTemplate(hotelId, chainId, lang) {
  const {
    host,
    URIs: { invoiceDeleteDocumentTemplate },
  } = apiConfig;

  const uri = `${host}${invoiceDeleteDocumentTemplate}`
    .replace(':chainId', chainId)
    .replace(':hotelId', hotelId)
    .replace(':lang', lang);

  return await axios.delete(uri).then(res => res.data);
}
